import {
	ActiveContainer,
	CardContainer,
	Chip,
	Column,
	Discount,
	DiscountContainer,
	DownCircle,
	Event,
	Name,
	Row,
	UpCircle,
	Uses,
} from './PromoCodeCard.styles';
import { FC, memo } from 'react';
import { chipText, typeText } from './utils';
import { generatePath, useHistory, useParams } from 'react-router-dom';

import { Icon } from 'features/common/components/Icon';
import { IdParamsType } from 'utils/types';
import { PromoCodeCardProps } from './types';
import { ROUTES } from 'features/routes';
import { RootState } from 'store';
import { XS } from 'features/common/components/Icon/utils';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const PromoCodeCard: FC<PromoCodeCardProps> = ({
	name,
	amount,
	isActive,
	used,
	type,
	references,
	background,
	onClick,
	isPercentage,
	id,
}: PromoCodeCardProps) => {
	const { t } = useTranslation();
	const { push } = useHistory();
	const { id: eventId } = useParams<IdParamsType>();
	const { isPunchup } = useSelector((state: RootState) => state.auth);

	const handleOnClick = () => {
		if (isPunchup) {
			push(generatePath(ROUTES.EVENT_PROMO_CODES_EDIT_FORM_PATH, { eventId, id }));
		} else {
			push(generatePath(ROUTES.PROMO_CODES_EDIT_PATH, { id, type: typeText[type] }));
		}
	};

	return (
		<CardContainer onClick={onClick ?? handleOnClick}>
			<UpCircle background={background} />
			<DownCircle background={background} />
			<DiscountContainer type={type}>
				<Discount type={type}>{`${isPercentage ? amount + '%' : '$' + amount}`}</Discount>
			</DiscountContainer>
			<Column>
				<Row>
					<Name>{name}</Name>
					<ActiveContainer>
						<Icon iconName={isActive ? 'activeCircle' : 'inactiveCircle'} size={XS} />
						{t(isActive ? 'dashboard-promoCodes-active' : 'dashboard-promoCodes-inactive')}
					</ActiveContainer>
				</Row>
				<Event>{references.length === 1 ? references[0].name : t('dashboard-promoCodes-multipleEvents')}</Event>
				<Uses>{`${used} ${t('dashboard-promoCodes-uses')}`}</Uses>
				<Chip type={type}>{chipText[type]}</Chip>
			</Column>
		</CardContainer>
	);
};

const memorizedPromoCodeCard: FC<PromoCodeCardProps> = memo(PromoCodeCard);

export { memorizedPromoCodeCard as PromoCodeCard };
